import { atom } from 'jotai'

export const paramsPortalAtom = atom<Element | undefined>(undefined)
